import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// User Auth
import Login from "@/pages/auth/Login";
import ProtectedRoute from "@/routes/ProtectedRoute";

// Admin
import AdminLayout from "@/pages/admin/layout/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Academies from "@/pages/admin/academies/Academies";
import Plans from "@/pages/admin/Plans";
import Faqs from "@/pages/admin/Faqs";

// Academy Auth
import AcademyLogin from "@/pages/academy_admin/auth/Login";
import AcademyProtectedRoute from "@/routes/AcademyProtectedRoute";

// Academy Admin
import AcademyAdminLayout from "@/pages/academy_admin/layout/AcademyAdminLayout";
import AcademyAdminDashboard from "@/pages/academy_admin/Dashboard";
import CreateTrainer from "@/pages/academy_admin/trainers/CreateTrainer";
import AcademyPlans from "@/pages/academy_admin/Plans";
import AcademyFaqs from "@/pages/academy_admin/Faqs";
import AiFeatures from "@/pages/admin/AiFeatures";
import Landing from "@/pages/admin/Landing";
import Testimonials from "@/pages/admin/Testimonials";
import Categories from "@/pages/academy_admin/Categories";
import TrainerPage from "@/pages/public/TrainerPage";


// trainer Admin
import TrainerLogin from "@/pages/trainer/auth/Login";
import TrainerProtectedRoute from "@/routes/TrainerProtectedRoute";
import TrainerLayout from "@/pages/trainer/layout/TrainerLayout";
import TrainerDashboard from "@/pages/trainer/Dashboard";
import CreateStudent from "@/pages/trainer/students/CreateStudent";
import AdminContacts from "@/pages/admin/AdminContacts";
import Contacts from "@/pages/academy_admin/Contacts";
import TrainerContacts from "@/pages/trainer/Contacts";
import CreateCourse from "@/pages/trainer/courses/CreateCourse";
import TrainerCourses from "@/pages/trainer/courses/TrainerCourses";
import TrainerCourseContent from "@/pages/trainer/courses/TrainerCourseContent";
import AcademyPage from "@/pages/public/AcademyPage";
import AcademyTestimonials from "@/pages/academy_admin/Testimonials";
import AcademyCategoryCoursesPage from "@/pages/academy_admin/AcademyCategoryCoursesPage";
import CoursePage from "@/pages/public/CoursePage";

// Student Auth
import StudentLogin from "@/pages/student/auth/Login";
import StudentProtectedRoute from "@/routes/StudentProtectedRoute";
import StudentRegister from "@/pages/student/StudentRegister";

// Student
import StudentLayout from "@/pages/student/layout/StudentLayout";
import StudentDashboard from "@/pages/student/Dashboard";
import StudentCourseWatch from "@/pages/student/StudentCourseWatch";
import MyCourses from "@/pages/student/my-courses";


function App() {
  return (
    <Router>
      <Routes>

        {/* ================= User Login ================= */}
        <Route path="/login" element={<Login />} />

        {/* ================= Academy Login ================= */}
        <Route path="/academy-login" element={<AcademyLogin />} />

        {/* ================= Admin Routes ================= */}
        <Route path="/" element={<Landing />} />
        <Route path="/academy/:academyId" element={<AcademyPage />} />
        <Route path="/academies/:academyId/categories/:categoryId"element={<AcademyCategoryCoursesPage />}/>
        <Route path="/trainers/:trainerId" element={<TrainerPage />}/>
        <Route path="/courses/:courseId" element={<CoursePage />}/>





        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
              
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="academies" element={<Academies />} />
          <Route path="plans" element={<Plans />} />
          <Route path="faqs" element={<Faqs />} />
          <Route path="ai-features" element={<AiFeatures />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="contacts" element={<AdminContacts />} />

          


        </Route>

        {/* ============= Academy Admin Routes ============= */}
        <Route
          path="/academy-admin"
          element={
            <AcademyProtectedRoute>
              <AcademyAdminLayout />
            </AcademyProtectedRoute>
          }
        >
          <Route index element={<AcademyAdminDashboard />} />
          <Route path="trainers/create" element={<CreateTrainer />} />
          <Route path="plans" element={<AcademyPlans />} />
          <Route path="faqs" element={<AcademyFaqs />} />
          <Route path="categories" element={<Categories />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="testimonials" element={<AcademyTestimonials />} />



        </Route>

<Route path="/trainer-login" element={<TrainerLogin />} />

        <Route
  path="/trainer"
  element={
    <TrainerProtectedRoute>
      <TrainerLayout />
    </TrainerProtectedRoute>
  }
>
  <Route index element={<TrainerDashboard />} />
    <Route path="students/create" element={<CreateStudent />} />
    <Route path="contacts" element={<TrainerContacts />} />
    <Route path="courses/create" element={<CreateCourse />} />
    
    <Route path="/trainer/courses" element={<TrainerCourses />} />
    <Route path="/trainer/courses/:courseId/content" element={<TrainerCourseContent />} />
  </Route>

{/* ================= Student Login ================= */}
<Route path="/student-login" element={<StudentLogin />} />

<Route
  path="/academy/:academyId/student/register"
  element={<StudentRegister />}
/>

{/* ================= Student Routes ================= */}
<Route
  path="/student"
  element={
    <StudentProtectedRoute>
      <StudentLayout />
    </StudentProtectedRoute>
  }
>
  <Route index element={<StudentDashboard />} />

  <Route path="courses/:courseId/watch" element={<StudentCourseWatch />} />
  <Route path="my-courses" element={<MyCourses />} />
  
</Route>









      </Routes>
    </Router>
  );
}

export default App;
